const standardPlusOptionSets = {53278129226042:'403670',53278119330106:'424002',53278119362874:'424003',53278119395642:'424004',53278119428410:'424005'};

// A pack may change before OPTIS or the theme finishes updating its form.
export function radioPackOptionsReady(id, selectedId, optionSetIds, apiReady) {
  const expected = standardPlusOptionSets[id];
  if (!expected && !standardPlusOptionSets[selectedId]) return true;
  return Boolean(expected && apiReady && id === selectedId &&
    optionSetIds.length === 1 && String(optionSetIds[0]) === expected);
}

export const radioPackUnits = {53704230797626:2,53278119330106:2,53704230830394:4,53278119362874:4,53704230863162:6,53278119395642:6,53704230895930:8,53278119428410:8,53704230928698:10};

export function radioServiceKey(properties = {}) {
  const service = String(Object.entries(properties).find(([key]) => key.trim().toLowerCase() === 'service')?.[1] || '').trim().toLowerCase();
  if (/\b(?:multi.?year|[2-9]\s*[- ]?\s*(?:year|yr)|lifetime)\b/.test(service)) return null;
  if (!service || /^(north american\+|north american plus|global\s*50)(?:\s|$|[(-])/.test(service)) return '50';
  if (/^(global\s*100|global plus)(?:\s|$|[(-])/.test(service)) return '100';
  if (/^(global\s*200|super global)(?:\s|$|[(-])/.test(service)) return '200';
  return null;
}

export function includedRadioService(properties = {}) {
  return radioServiceKey(properties) !== null;
}

export function radioRenewalPair(id, quantity, properties, config, pair) {
  if (!Number.isSafeInteger(id) || !Number.isSafeInteger(quantity) || quantity < 1 || !config.variants.includes(id)) throw new Error('Invalid radio selection');
  const service = config.services[radioServiceKey(properties)];
  if (!service) return null;
  return [
    {id, quantity, properties: {...properties, _t2m_radio_pair: pair}},
    {id: service.id, quantity: quantity * (radioPackUnits[id] || 1), selling_plan: config.plan, parent_id: id,
      properties: {'Renewal terms': service.terms, _t2m_radio_pair: pair, _t2m_included_year: '1'}}
  ];
}

export function validRadioPair(cart, pair, config, id, quantity) {
  const items = cart.items.filter(item => item.properties?._t2m_radio_pair === pair);
  const parents = items.filter(item => Number(item.variant_id) === id);
  if (parents.length !== 1) return false;
  const [parent] = parents;
  const service = config.services[radioServiceKey(parent.properties)];
  if (!service) return false;
  const children = items.filter(item => Number(item.variant_id) === service.id);
  if (children.length !== 1 || items.length !== 2) return false;
  const [child] = children;
  return parent.quantity === quantity && includedRadioService(parent.properties) &&
    (child.parent_relationship?.parent_key === parent.key || (!child.parent_relationship && Number(child.properties?._t2m_radio_parent) === id)) &&
    child.quantity === quantity * (radioPackUnits[id] || 1) &&
    Number(child.selling_plan_allocation?.selling_plan?.id) === config.plan &&
    child.requires_shipping === false && child.final_line_price === 0;
}

if (typeof customElements !== 'undefined' && !customElements.get('t2m-radio-renewal')) {
  let pending = false;
  const route = path => (window.Shopify?.routes?.root || '/') + path;
  async function request(path, body) {
    const response = await fetch(route(path), {
      method: body ? 'POST' : 'GET',
      headers: {'Content-Type':'application/json', Accept:'application/json'},
      ...(body ? {body:JSON.stringify(body)} : {})
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || 'Cart update failed');
    return result;
  }

  class RadioRenewal extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.config = JSON.parse(this.querySelector('[data-radio-config]').textContent);
      this.form?.addEventListener('change', this.sync);
      this.form?.addEventListener('input', this.sync);
      document.addEventListener('BSSOptionSelectionChanged', this.queueSync);
      document.addEventListener('BSSchangeProductPrice', this.queueSync);
      this.sync();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('change', this.sync);
      this.form?.removeEventListener('input', this.sync);
      document.removeEventListener('BSSOptionSelectionChanged', this.queueSync);
      document.removeEventListener('BSSchangeProductPrice', this.queueSync);
    }
    values() {
      const data = new FormData(this.form);
      const properties = {};
      for (const [key, value] of data) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) {
          if (typeof value !== 'string') throw new Error(this.dataset.failed);
          properties[match[1]] = value;
        }
      }
      const selection = window.BSS_PO?.getSelectedOptions?.getValue('Service');
      if (selection) {
        const serviceProperty = Object.keys(properties).find(key => key.trim().toLowerCase() === 'service') || ' Service';
        properties[serviceProperty] = Array.isArray(selection) ? selection.join(', ') : String(selection);
      }
      return {id:Number(data.get('id')), quantity:Number(data.get('quantity') || 1), properties};
    }
    packOptionsReady(values) {
      const product = this.closest('product-component');
      const selected = product?.querySelector('variant-picker input[data-variant-id]:checked');
      const selectedId = selected ? Number(selected.dataset.variantId) : values.id;
      const optionSetIds = [...(product || this.form).querySelectorAll('[id^="po_container--"]')]
        .filter(element => element.getClientRects().length > 0)
        .map(element => element.id.slice('po_container--'.length));
      const api = window.BSS_PO?.getSelectedOptions;
      return radioPackOptionsReady(values.id, selectedId, optionSetIds,
        typeof api?.isValid === 'function' && typeof api?.getValue === 'function');
    }
    showPackLoading(error) {
      const selected = this.closest('product-component')?.querySelector('variant-picker input[data-variant-id]:checked');
      const url = new URL(window.location.href);
      if (selected?.dataset.variantId) url.searchParams.set('variant', selected.dataset.variantId);
      const reload = document.createElement('a');
      reload.href = url.toString();
      reload.textContent = 'Reload selected pack';
      error.textContent = 'Your pack options are still updating. Wait a moment, or reload your selected pack before adding it to the cart. ';
      error.append(reload);
      error.dataset.packLoading = 'true';
      error.hidden = false;
      error.focus();
    }
    queueSync = () => requestAnimationFrame(this.sync);
    sync = () => {
      if (!this.form) return;
      let values;
      try { values = this.values(); } catch { return; }
      const error = this.querySelector('[data-radio-error]');
      if (error?.dataset.packLoading && this.packOptionsReady(values)) {
        error.hidden = true;
        delete error.dataset.packLoading;
      }
      const service = this.config.services[radioServiceKey(values.properties)];
      const eligible = Boolean(service);
      this.querySelector('[data-radio-base]').hidden = !eligible;
      this.querySelector('[data-radio-upgrade]').hidden = eligible;
      if (!service) return;
      this.querySelector('[data-radio-price]').innerHTML = service.description;
      this.dataset.available = String(service.available);
      const count = values.quantity * (radioPackUnits[values.id] || 1);
      const total = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.config.currency}).format(service.price * count / 100);
      const summary = count === 1 ? this.dataset.summaryOne : this.dataset.summaryOther;
      this.querySelector('[data-radio-total]').textContent = summary.replace('[count]', String(count)).replace('[total]', total);
    };
    reset() {
      this.controls?.forEach(([element,disabled]) => { element.disabled = disabled; });
      this.controls = undefined;
      this.removeAttribute('aria-busy');
      pending = false;
    }
    async add() {
      if (pending) return true;
      if (!this.form?.reportValidity()) return true;
      const error = this.querySelector('[data-radio-error]');
      error.hidden = true;
      let values;
      try { values = this.values(); } catch (failure) { error.textContent = failure.message; error.hidden = false; return true; }
      if (!this.packOptionsReady(values)) {
        this.showPackLoading(error);
        return true;
      }
      if (window.BSS_PO?.getSelectedOptions?.isValid() === false) {
        error.textContent = this.dataset.optionsRequired;
        error.hidden = false;
        error.focus();
        return true;
      }
      if (!includedRadioService(values.properties)) return false;
      this.sync();
      if (this.dataset.available !== 'true') { error.textContent = this.dataset.unavailable; error.hidden = false; return true; }
      const pair = crypto.randomUUID();
      let items;
      try { items = radioRenewalPair(values.id, values.quantity, values.properties, this.config, pair); }
      catch { error.textContent = this.dataset.failed; error.hidden = false; return true; }
      pending = true;
      const controls = [...this.form.querySelectorAll('button, input, select, textarea')].map(element => [element,element.disabled]);
      this.controls = controls;
      controls.forEach(([element]) => { element.disabled = true; });
      this.setAttribute('aria-busy','true');
      try {
        await request('cart/add.js',{items:[items[0]]});
        const radioCart = await request('cart.js');
        const parents = radioCart.items.filter(item => item.properties?._t2m_radio_pair === pair && Number(item.variant_id) === values.id);
        if (parents.length !== 1 || parents[0].quantity !== values.quantity || radioServiceKey(parents[0].properties) !== radioServiceKey(values.properties)) throw new Error(this.dataset.failed);
        const child = {...items[1],properties:{...items[1].properties,_t2m_radio_parent:String(values.id),Radio:this.config.title}};
        delete child.parent_id;
        await request('cart/add.js',{items:[child]});
        const cart = await request('cart.js');
        if (!validRadioPair(cart,pair,this.config,values.id,values.quantity)) throw new Error(this.dataset.failed);
        window.location.assign(route('cart'));
      } catch (failure) {
        try {
          const cart = await request('cart.js');
          const added = cart.items.filter(item => item.properties?._t2m_radio_pair === pair);
          for (const parent of added.filter(item => !item.parent_relationship?.parent_key)) await request('cart/change.js',{id:parent.key,quantity:0});
          const remaining = (await request('cart.js')).items.filter(item => item.properties?._t2m_radio_pair === pair);
          for (const item of remaining) await request('cart/change.js',{id:item.key,quantity:0});
        } catch {}
        error.textContent = this.dataset.failed;
        error.hidden = false;
        error.focus();
        this.reset();
      }
      return true;
    }
  }
  customElements.define('t2m-radio-renewal',RadioRenewal);
  window.addEventListener('pageshow',event => {
    if (event.persisted) document.querySelectorAll('t2m-radio-renewal').forEach(panel => panel.reset());
  });
}



